module.exports = __webpack_public_path__ + "img/4c.05aeec25.png";